import { FC, ReactNode } from "react";
import { getDataAutomationGroup, getDataLinkAttributes } from "@/helpers";
import cn from "classnames";
import { Theme } from "@/types";
import { Link as LinkProps } from "@/types/General/Link";
import Link from "@/components/Link";

export type ChromelessHeaderProps = {
  logo?: ReactNode;
  link?: LinkProps;
  theme?: Theme | "cool-gray";
  icon?: ReactNode;
};

export const ChromelessHeader: FC<ChromelessHeaderProps> = ({
  logo,
  link,
  theme,
  icon,
}) => (
  <header
    className={cn(
      "relative",
      theme === "cool-gray" ? "bg-swdc-cool-gray-600" : "bg-background",
    )}
    data-theme={theme}
  >
    <div className="swdc-container flex h-22 w-full items-center sm:h-28">
      <Link
        href={link && link.href ? link.href : "/"}
        className={cn(
          "z-1 mr-22 flex h-full items-center justify-center px-8 sm:px-10",
          theme === "orange" ? "bg-swdc-white" : "bg-swdc-orange-400",
        )}
        {...getDataLinkAttributes({
          dlt: link?.dlt || "Chromeless Header",
          dld: link?.dld || "SolarWinds Logo",
        })}
        {...getDataAutomationGroup("link")}
      >
        <span className="sr-only">{link?.title}</span>
        {logo}
      </Link>
      <div className="absolute right-6">{icon}</div>
    </div>
    <div className="border-symbol-silver-300-graphic absolute top-1/2 left-0 w-full border-t" />
  </header>
);

export default ChromelessHeader;
